module.exports = __webpack_public_path__ + "media/images/emblems/Ollon-coat_of_arms-81c8557e0115e6e6038cb4c3bde8c3ba.svg";